/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Display {
    BASIC = 'BASIC',
    BEST_SELLER = 'BEST_SELLER',
}
